import React from 'react';
import InteractionsMedicamenteusesForm from './InteractionsMedicamenteusesForm';

function InteractionsMedicamenteusesView() {
  return (
    <>
      <style>{`
        .imv-container {
          min-height: 100vh;
          padding: 28px 32px 48px;
          color: #1f2937;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        .imv-wrapper {
          width: 100%;
          max-width: 1600px;
          margin: 0 auto;
        }

        .imv-header {
          display: flex;
          align-items: center;
          gap: 22px;
          padding: 34px 40px;
          margin-bottom: 24px;
          background: linear-gradient(120deg, #fff 0%, #f3fbfd 100%);
          border: 1px solid #e4eef1;
          border-radius: 18px;
          box-shadow: 0 8px 24px rgba(31, 58, 69, 0.05);
        }

        .imv-header-icon {
          display: flex;
          flex: 0 0 64px;
          align-items: center;
          justify-content: center;
          width: 64px;
          height: 64px;
          color: var(--app-primary-color);
          background: var(--app-primary-tint);
          border: 1px solid rgba(var(--app-primary-rgb), 0.18);
          border-radius: 16px;
        }

        .imv-heading {
          min-width: 0;
        }

        .imv-eyebrow {
          display: block;
          margin-bottom: 5px;
          color: #64748b;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 1.1px;
          text-transform: uppercase;
        }

        .imv-title {
          margin: 0;
          color: #152b36;
          font-size: 32px;
          font-weight: 700;
          letter-spacing: -0.5px;
          line-height: 1.25;
        }

        .imv-subtitle {
          max-width: 680px;
          margin: 8px 0 0;
          color: #64748b;
          font-size: 12px;
          line-height: 1.65;
        }

        .imv-form {
          padding: 0;
          background: transparent;
          border: 0;
          border-radius: 0;
          box-shadow: none;
        }

        @media (max-width: 768px) {
          .imv-container {
            padding: 20px 14px 32px;
          }

          .imv-header {
            align-items: flex-start;
            gap: 15px;
            padding: 22px 20px;
            border-radius: 15px;
          }

          .imv-header-icon {
            flex-basis: 48px;
            width: 48px;
            height: 48px;
            border-radius: 13px;
          }

          .imv-title {
            font-size: 22px;
          }

          .imv-subtitle {
            font-size: 11px;
          }

        }

        @media (prefers-reduced-motion: reduce) {
          .imv-container *,
          .imv-container *::before,
          .imv-container *::after {
            scroll-behavior: auto !important;
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
        }
      `}</style>

      <main className="imv-container">
        <div className="imv-wrapper">

          <section className="imv-form" aria-label="Formulaire d'analyse des interactions">
            <InteractionsMedicamenteusesForm />
          </section>
        </div>
      </main>
    </>
  );
}

export default InteractionsMedicamenteusesView;
